export default __webpack_public_path__ + "static/media/jibon-mobile-one.0d141121.png";